module.exports = __webpack_public_path__ + "static/media/Badge_SvgCommunityMaster_disabled.4f24d748.svg";